import "@/App.css";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import Benefits from "@/components/Benefits";
import ProductShowcase from "@/components/ProductShowcase";
import WhyAhaario from "@/components/WhyAhaario";
import Footer from "@/components/Footer";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <Navigation />
      <main>
        <Hero />
        <Benefits />
        <ProductShowcase />
        <WhyAhaario />
      </main>
      <Footer />
    </div>
  );
}

export default App;
